import $ from 'jquery';
import 'jquery-touchswipe/jquery.touchSwipe';
import Carousel from 'bootstrap/js/src/carousel';
import isEqual from 'lodash/isEqual';
import FavouriteArrangements from '../components/FavouriteArrangements';
import RecentlyViewedItems from '../components/RecentlyViewedItems';
import SubscribeToArrangementChangesComponent from '../components/SubscribeToArrangementChangesComponent';
import {handlePageView} from '../helpers/pageViewHelpers';
import {onViewportEnter} from '../helpers/lazyInit';
import abTestService from '../services/abTestService';
import userCookiesService from '../services/userCookiesService';
import {lazyLoad} from '../helpers/lazyLoadHelpers';
import {
	initPaymentInstallmentsTestForArrangementPage,
	initPaymentInstallmentsTestForArrangementList,
	initVBTHomepageAboveTheFoldTest,
	initStayMinimumNightsInfoTest
} from '../helpers/abTestHelpers';
import {initTicketInformationBannerBlock} from '../helpers/ticketInformationBannerHelpers';
import PackageTypeSelector from '../components/packageTypeSelector';

class ArrangementPage {
	constructor() {
		this.selectedOneMergedTicket = false;
		this.widget = null;
		
		this.init();
	}

	init() {
		initTicketInformationBannerBlock();
		this.initPackageTypeSelector();
		
		if (this.hasWidget()) {
			this.initContent();
		}

		$(document.body).on('lazyLoadError', (ev, element) => {
			$(element).hide();
		});

		requestAnimationFrame(() => {
			this.initFavouriteArrangementsHeaderBlock();
			this.loadEventGallery();
			this.initSubscribeToArrangementChangesTest();
			this.initMissingInfoModal();
            this.initEvents();
			
			if (this.hasWidget()) {
				this.loadWidgetOnNeed();
				this.initRecentlyViewedItems();
				this.trackScheduledArrangement();
			}
			
			if (abTestService.isAnyVariationActive(['increase_user_trust_no', 'increase_user_trust_yes'])) {
				abTestService.sendEvent('LA_DK_v1_user_trust_level', 'arrangementPageOpen');
			}

			// SPE-3255
			initStayMinimumNightsInfoTest();
		});
		
		if (this.hasWidget()) {
			$(window).one(
				'load',
				() => {
					this.initCarousel();
					handlePageView({
						'saveUrl' : `/user/viewed/arrangement/${this.getArrangementId()}`,
						'fetchUrl': `/viewed/arrangement/${this.getArrangementId()}`
					});
					initPaymentInstallmentsTestForArrangementPage();
				}
			);
		}
	}
	
	initFavouriteArrangementsHeaderBlock() {
		let onFavouriteChange = null;

		const $desktopWishListIcon = $('.wishlistIconDesktop .wishlistIcon');

		if ($desktopWishListIcon.length) {
			const currentArrangementId 			= this.getArrangementId(),
				  isCurrentArrangementFavorited = userCookiesService.getFavouriteArrangementIds().includes(currentArrangementId);

			onFavouriteChange = ({id, added}) => {
				if (id === currentArrangementId) {
					this.toggleFavouriteInfoTexts(added);
				}
			};

			if (!isCurrentArrangementFavorited) {
				this.toggleFavouriteInfoTexts(false);
			}

			// make the toggle texts toggle the arrangement in the favourites
			$('.wishlistIcon-addText, .wishlistIcon-removeText').on('click', () => {
				$desktopWishListIcon.find('i.show').trigger('click');
			});
		}

		new FavouriteArrangements({
			onFavouriteChange
		});
	}

	toggleFavouriteInfoTexts(wasAdded) {
		$('.wishlistIcon-addText').toggleClass('d-lg-inline-block', !wasAdded);
		$('.wishlistIcon-removeText').toggleClass('d-lg-inline-block', wasAdded);
	}

	loadWidgetOnNeed() {
		if ($('#searchWidget').length) {
			onViewportEnter(
				document.querySelectorAll('#arrangementPage .package-bookBtnStyle'),
				() => {
					this.loadWidget();
				},
				{
					'threshold': 0.5
				}
			);
		}
	}

	loadWidget() {
		if (this.isWidgetAvailable()) {
			$(document).trigger('widgetReady');

			return Promise.resolve();
		}
		
		return Promise.all([
			import(
				/* webpackChunkName: "formatDate" */
				`../locales/${globalParams.siteLocale}/formatDate`
			),
			import(
				/* webpackChunkName: "SearchWidget" */
				'../components/amandedPackageSearchFlow/APS_flow'
			)
		])
		.then((
			[
				{'default':formatDate},
				{'default':APS_flow} // eslint-disable-line camelcase
			]
		) => {
			window.widgetParams.formatDate = formatDate;
			window.widgetParams.awinParams = this.getAwinParams();

			this.widget = new APS_flow(window.widgetParams);

			window.originalWidgetParams = $.extend(true, {}, window.widgetParams);
		});
	}

	loadEventGallery() {
		const $galleryElement = $('.galleryWithPreview');

		if (!$galleryElement.length) {
			return;
		}

		onViewportEnter(
			$galleryElement.get(),
			() => {
				import(
					'../components/GalleryWithPreview'
					)
					.then(({'default': GalleryWithPreview}) => {
						new GalleryWithPreview($galleryElement);
					});
			}
		);
	}
	
	initEvents() {
		initPaymentInstallmentsTestForArrangementList();
	
        // SCP-3173 - TODO: remove this AB-test tracking once the it is finished
        initVBTHomepageAboveTheFoldTest('storefront_match_page_visit');
	}
	
	loadCarouselImages = (carousel) => {
		lazyLoad({
			'elements_selector': `#${carousel.id} .carousel-item .lazy`
		}).loadAll();
	};

	initCarousel() {
		const carousels = document.querySelectorAll('.carousel');

		carousels.forEach((carousel) => {
			new Carousel(carousel);

			carousel.addEventListener('touchend', () => {
				this.loadCarouselImages(carousel);
			});

			carousel.addEventListener('click', () => {
				this.loadCarouselImages(carousel);
			});
		});
	}
	
	initSubscribeToArrangementChangesTest() {
		new SubscribeToArrangementChangesComponent(
			{
				'buttonElements': document.querySelectorAll('.subscribeToArrangementChangesButton'),
				'arrangementId' : this.getArrangementId()
			}
		);
	}
	
	/**
	 * Get the actual arrangement-item, or get the related data by id.
	 * @param {number} id
	 * @returns {Object}
	 */
	getArrangementWidgetParams(id) {
		const {arrangements} = window.widgetParams;

		return arrangements[id || window.APS_selected];
	}

	/**
	 * @returns {number}
	 */
	getArrangementId() {
		return $('.arrangementId').data('arrangementId');
	}
	
	/**
	 * @returns {string}
	 */
	getArrangementTitle() {
		const arrangement = this.getArrangementWidgetParams(this.getArrangementId());
		
		return `${arrangement.homeTeam} - ${arrangement.awayTeam}`;
	}
	
	/**
	 * Get the first item of the Arrangements object.
	 * @returns {*}
	 */
	getRawArrangement() {
		const {arrangements} = window.widgetParams;

		return arrangements[Object.keys(arrangements)[0]];
	}

	isMergedArrangement() {
		return this.getRawArrangement().isMergedArrangement;
	}

	/**
	 * Need to set this propertie if not exists.
	 */
	setDefaultObjectForMergedArrangements() {
		if (!window.ticketCategoryIdsForMergedArrangements) {
			window.ticketCategoryIdsForMergedArrangements = {};
		}
	}

	/**
	 * Need to sort the invoked 2 arrays before the comparision.
	 * @param {!Array} array
	 * @returns {*}
	 */
	sortTicketCategoryArrays(array) {
		/* eslint-disable-next-line id-length */
		return array.sort((a, b) => a - b);
	}

	/**
	 * @param {*} btn
	 * @returns {Object}
	 */
	recommendedPackageConstants(btn) {
		const input = btn.find('.ticketCategoryIdInput:radio'),
			  arrangement = input.data('arrangementid') ? window.widgetParams.arrangements[input.data('arrangementid')] || null : null,
			  isRecommendedBtn = btn.hasClass('package-recommendedBookBtn');

		return {
			input,
			arrangement,
			isRecommendedBtn
		};
	}

	/**
	 * Display the widget with these properties and extra effects.
	 * @param {jQuery} widgetElement
	 * @param {jQuery} actualMatchPageBookBtn
	 */
	showWidgetAfterClick(widgetElement, actualMatchPageBookBtn) {
		const {input, arrangement, isRecommendedBtn} = this.recommendedPackageConstants(actualMatchPageBookBtn);

		this.widget.APS.handleTicketCategoryChange(input, arrangement, isRecommendedBtn);

		this.displayWidget(widgetElement);
	}

	/**
	 * Reusable widget display animation helper
	 * @param {jQuery} widgetElement
	 */
	displayWidget(widgetElement) {
		$('.headerContainer, .highlight').addClass('openedWidget');
		widgetElement.addClass('openedWidget pulse');
		
		this.scrollToTarget(widgetElement, 110);

		setTimeout(() => {
			widgetElement.removeClass('pulse');
			$('.highlight').removeClass('openedWidget');
		}, 1500);
	}

	/**
	 * @param {jQuery} obj
	 * @param {number} [topPadding]
	 * @returns {boolean}
	 */
	scrollToTarget(obj, topPadding = 150) {
		const body = $('html, body');

		body.stop().animate(
			{
				'scrollTop': obj.offset().top - topPadding
			},
			500,
			'swing'
		);

		return false;
	}

	instructorInit(param) {
		$('.topHelperForTicketSelection').css('width', `${$(window).width() * param.slideNum}px`);
	}

	/**
	 * When the user selected a ticket by clicking, then this method will affect.
	 * @param {jQuery} btnOfmergedArrangementBlock
	 * @param {jQuery} actualMatchPageBookBtn
	 * @param {Object|undefined} blockSettings
	 */
	clickOnTicketCategoryBtn(btnOfmergedArrangementBlock, actualMatchPageBookBtn, blockSettings) {
		const me = this,
			widgetElement                   = $('#searchWidget'),
			actualSelectedTicketCategory    = parseInt(actualMatchPageBookBtn.find('.ticketCategoryIdInput:radio').data('ticketid')),
			selectedTicketCategories        = [],
			$helpersInner                   = $('.topHelperForTicketSelection'),
			animateDuration                 = 1000;

		btnOfmergedArrangementBlock.removeClass('active');

		if (blockSettings?.isRecommended) {
			$('.package-bookBtnStyle').removeClass('active');
		} else {
			$('.package-recommendedBookBtn').removeClass('active');
		}

		actualMatchPageBookBtn
            .addClass('active')
            .find('.ticketCategoryIdInput:radio')
            .prop('checked', true);

		if (blockSettings?.mergedBlockId) {
			window.ticketCategoryIdsForMergedArrangements[blockSettings.mergedBlockId] = parseInt(actualSelectedTicketCategory);

			if (
				typeof window.ticketCategoryIdsForMergedArrangements[1] !== 'undefined' &&
                typeof window.ticketCategoryIdsForMergedArrangements[2] !== 'undefined'
			) {
				selectedTicketCategories.push(
					window.ticketCategoryIdsForMergedArrangements[1],
					window.ticketCategoryIdsForMergedArrangements[2]
				);

				const userSelectedTicketCategoryArray = me.sortTicketCategoryArrays(selectedTicketCategories),
					arrangementParams = me.getArrangementWidgetParams(this.getArrangementId()),
					ticketCategories = arrangementParams ? arrangementParams.mergedTicketCategories : null;

				if (!ticketCategories) {
					window.calculatedMergedTicketCategoryId = userSelectedTicketCategoryArray[0];
					me.showWidgetAfterClick(widgetElement, actualMatchPageBookBtn);

					return;
				}

				$.each(ticketCategories, (index, value) => {
					const currentArray = me.sortTicketCategoryArrays(value.mergedIds.map((id) => parseInt(id)));

					if (isEqual(currentArray, userSelectedTicketCategoryArray)) {
						window.calculatedMergedTicketCategoryId = parseInt(index);
						me.showWidgetAfterClick(widgetElement, actualMatchPageBookBtn);
					}
				});
			}

			if (window.topHelperForTicketSelection) {
				me.instructorInit({'slideNum': 3});

				if (blockSettings.mergedBlockId === 1) {
					if (window.ticketCategoryIdsForMergedArrangements[2]) {
						$helpersInner.animate({'left': `-${$(window).width() * 2}`}, animateDuration);
						me.scrollToTarget(widgetElement);
					} else {
						$helpersInner.animate({'left': `-${$(window).width()}`}, animateDuration);
						me.scrollToTarget($('#mergedEvent-matchBlock-2'));
					}
				}

				if (blockSettings.mergedBlockId === 2) {
					if (window.ticketCategoryIdsForMergedArrangements[1]) {
						$helpersInner.animate({'left': `-${$(window).width() * 2}`}, animateDuration);
						me.scrollToTarget(widgetElement);
					} else {
						$helpersInner.animate({'left': 0}, animateDuration);
						me.scrollToTarget($('#mergedEvent-matchBlock-1'));
					}
				}
			}
		} else {
			me.showWidgetAfterClick(widgetElement, actualMatchPageBookBtn);

			if (window.topHelperForTicketSelection) {
				me.instructorInit({'slideNum': 2});
				$helpersInner.animate({'left': `-${$(window).width()}`}, animateDuration);
				me.scrollToTarget($('#arrangementPage'));
			}
		}
	}

	initContent() {
		const me = this;

		if (this.isMergedArrangement()) {
			if (window.topHelperForTicketSelection) {
				this.instructorInit({'slideNum': 3});
			}

			const mergedArrangementBlock1         = 1,
				mergedArrangementBlock2         = 2,
				btnOfmergedArrangementBlock1    = $(`#mergedEvent-matchBlock-${mergedArrangementBlock1}`).find('.package-bookBtn'),
				btnOfmergedArrangementBlock2    = $(`#mergedEvent-matchBlock-${mergedArrangementBlock2}`).find('.package-bookBtn');

			btnOfmergedArrangementBlock1.on('click', function() {
				me.scrollToNextTicket($('#mergedEvent-matchBlock-2'));

				me.setDefaultObjectForMergedArrangements();
				me.clickOnTicketCategoryBtn(btnOfmergedArrangementBlock1, $(this), {'mergedBlockId': mergedArrangementBlock1});
			});

			btnOfmergedArrangementBlock2.on('click', function() {
				me.scrollToNextTicket($('#mergedEvent-matchBlock-1'));

				me.setDefaultObjectForMergedArrangements();
				me.clickOnTicketCategoryBtn(btnOfmergedArrangementBlock2, $(this), {'mergedBlockId': mergedArrangementBlock2});
			});
		} else {
			if (window.topHelperForTicketSelection) {
				this.instructorInit({'slideNum': 2});
			}

			const ticketCategoryClickTrackings = {
				'event'        : 'Compose Your Trip CTA',
				'eventCategory': 'Ecommerce',
				'eventAction'  : 'Event_Comp_Your_Trip_CTA',
				'eventLabel'   : 'Booking-Engine'
			},
			
			arrangementPageRecommendedBookBtn = $('#arrangementPage .package-recommendedBookBtn');

			arrangementPageRecommendedBookBtn.on('click', function() {
				me.clickOnTicketCategoryBtn(arrangementPageRecommendedBookBtn, $(this), {'isRecommended': true});

				dataLayer.push(ticketCategoryClickTrackings);
			});

			const arrangementPageBookBtn = $('#arrangementPage .package-bookBtn');

			arrangementPageBookBtn.on('click', function() {
				me.clickOnTicketCategoryBtn(arrangementPageBookBtn, $(this));
				
				dataLayer.push(ticketCategoryClickTrackings);
			});
		}

		if (window.topHelperForTicketSelection) {
			const slideNum = this.isMergedArrangement() ? 3 : 2;

			$(window).on('resize', () => {
				requestAnimationFrame(() => {
					this.instructorInit({
						slideNum
					});
				});
			});
		}

		$('#matchWidgetBack i').on('click', () => {
			$('#arrangementPage, .headerContainer').removeClass('openedWidget');
			$('#searchWidget').removeAttr('style').removeClass('openedWidget');
		});

		$('#searchWidget').on('click', () => {
			if ($('#amandedPackageSearchFlow-passengersSelection').is(':visible')) {
				$('.progressBar ul li:eq(1), .progressBar ul li:eq(2)').addClass('done');
			}
		});

		$('.mobile-gallery-opener').on('click', () => {
			$('.galleryWithPreview a').first().trigger('click');
		});
	}

	initRecentlyViewedItems() {
		const recentlyViewed = new RecentlyViewedItems();

		recentlyViewed.saveViewedArrangement(this.getArrangementId());
	}

	trackScheduledArrangement() {
		dataLayer.push({
			'destinationId': this.getArrangementId(),
			'pageType'     : window.globalParams.pageType,
			'totalValue'   : window.arrangementGlobalParams.cheapestPackagePriceSeen
		});

		const defaultPassengerNumber = 2,
			  arrangement = this.getArrangementWidgetParams(this.getArrangementId()),
			  viewItemData = {
				'event'    : 'view_item',
				'ecommerce': {
					'currency': window.widgetParams.settings.currency,
					'value'   : arrangement.price.ticketWithHotel * defaultPassengerNumber,
					'items'   : [
						{
							'item_id'      : this.getArrangementId(),
							'item_name'    : this.getArrangementTitle(),
							'item_category': window.widgetParams.settings.labelId,
							'price'        : arrangement.price.ticketWithHotel * defaultPassengerNumber,
							'quantity'     : 1
						}
					]
				}
			};

		dataLayer.push(viewItemData);
	}

	hasWidget() {
		return !!window.widgetParams;
	}

	isWidgetAvailable() {
		return !!(this.widget?.APS && window.APS_selected);
	}

	getAwinParams() {
		const saveAwinKeys    = ['zanpid', 'awc'],
		      {searchParams}  = new URL(location.href),
		      savedAwinValues = new Map();

		saveAwinKeys.forEach((key) => {
			if (searchParams.get(key)) {
				savedAwinValues.set(key, searchParams.get(key));
			}
		});

		return savedAwinValues;
	}

	scrollToNextTicket(blockId) {
		const me = this;

		if (!me.selectedOneMergedTicket) {
			me.selectedOneMergedTicket = true;

			$('html, body').animate({
				'scrollTop': `${parseInt(blockId.offset().top) - 125}px`
			}, 200);
		}
	}
	
	initMissingInfoModal() {
		if (document.getElementById('missingInfoModal')) {
			import(
				'../components/MissingInfoBlock'
			)
			.then(({'default': MissingInfoBlock}) => {
				new MissingInfoBlock({
					'pageType': `Match Page: ${this.getArrangementTitle()}`
				});
			});
		}
	}

	initPackageTypeSelector() {
		if ($('.package-type-selector').length) {
			new PackageTypeSelector(this);
		}
	}
}

new ArrangementPage();